package one.healthium.payments

actual class BillingManager {
    actual suspend fun getProducts(options: List<one.healthium.payments.models.ProductOptions>): List<one.healthium.payments.models.ProductDetails> {
        return emptyList()
    }

    actual suspend fun launchPurchaseFlow(
        platformLauncher: one.healthium.base.launcher.PlatformLauncher,
        options: one.healthium.payments.models.PurchaseOptions
    ) {
    }

    actual suspend fun launchRestoreFlow() {
    }
}